module.exports = __webpack_public_path__ + "static/media/protein-powder.8902a44d.png";